// Compatibility shim: keeps the `toast` and `Toaster` API used across the
// codebase (`import { toast } from "sonner"`), but routes every call through
// our centered acknowledgement modal instead of corner toasts.
//
// Pages keep calling `toast.success(...)`, `toast.error(...)`, etc. — the
// difference is purely visual: a centered Dialog with an OK button now
// surfaces the message and the user must click to acknowledge it.

import NotificationDialog from "@/components/NotificationDialog";
import { pushNotification } from "@/lib/notify-store";

function makeToast(type) {
  return (message, opts = {}) => {
    pushNotification({ type, message, description: opts?.description || "" });
  };
}

const toast = (message, opts) => pushNotification({ type: "info", message, description: opts?.description || "" });
toast.success = makeToast("success");
toast.error = makeToast("error");
toast.warning = makeToast("warning");
toast.info = makeToast("info");
toast.message = (message, opts) => pushNotification({ type: "info", message, description: opts?.description || "" });
toast.dismiss = () => {}; // no-op — modal owns its own lifecycle

// `<Toaster />` is mounted once at the app root in App.js. Any extra props the
// caller passes (e.g. `richColors`, `position`) are ignored on purpose since
// the new modal has a single, fixed presentation.
const Toaster = () => <NotificationDialog />;

export { Toaster, toast };
